import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=754516c8&scoped=true"
import script from "./AddMemberModal.vue?vue&type=script&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&lang=js"
import style0 from "./AddMemberModal.vue?vue&type=style&index=0&id=754516c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754516c8",
  null
  
)

export default component.exports